module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }